import { InputProps } from "$store/components/wholesale/Input.tsx";
import { useSignal } from "@preact/signals";
import { fixMaxLengthWhenNumberInput } from "$store/sdk/format.ts";

export function InputPhone({
  name,
  placeholder,
  type = "text",
  gridColumn = "col-span-full",
  label,
  formatPhone,
  classes,
}: InputProps) {
  const formattedPhone = useSignal("");

  const handlePhoneInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value;
    if (!value) return;

    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
    value = value.replace(/(\d)(\d{4})$/, "$1-$2");

    return (formattedPhone.value = value);
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    fixMaxLengthWhenNumberInput(e);
    handlePhoneInput(e);
  };

  return (
    <div id={`input-${name}`} class={`grid content-start gap-1 ${gridColumn}`}>
      {label && (
        <label class="text-tw-neutral-500 text-sm font-semibold" htmlFor={name}>
          {label}
        </label>
      )}

      <input
        id={name}
        class={`${
          classes ??
            "w-full h-10 px-2 border border-tw-neutral-200 rounded text-tw-neutral-500 text-sm placeholder:text-tw-neutral-200 data-[error=true]:border-tw-danger-200 peer"
        }`}
        name={name}
        type={type}
        placeholder={placeholder}
        onInput={handleInput}
        value={formattedPhone.value}
        maxLength={formatPhone === "smartphone" ? 15 : 14}
      />

      <span
        class="hidden text-tw-danger-200 text-sm font-semibold peer-data-[error=true]:block"
        data-error-message
      />
    </div>
  );
}
